import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Toast } from './Toast';
import type { ToastMessage } from '../../../contexts/ToastContext';

interface ToastContainerProps {
    toasts: ToastMessage[];
    onRemove: (id: string) => void;
}

export const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onRemove }) => {

    useEffect(() => {
        if (toasts.length > 1) {
            const olderToasts = toasts.slice(0, -1);
            olderToasts.forEach(oldToast => {
                onRemove(oldToast.id);
            });
        }
    }, [toasts, onRemove]);

    const latestToast = toasts[toasts.length - 1];

    return ReactDOM.createPortal(
        <div
            aria-label="Уведомления"
            className={[
                'fixed top-6 left-1/2 -translate-x-1/2',
                'flex flex-col items-center',
                'z-[9999] pointer-events-none',
                'w-full px-4 sm:px-0 sm:w-auto',
            ].join(' ')}
        >
            {latestToast && (
                <div className="w-full flex justify-center pointer-events-auto">
                    <Toast
                        key={latestToast.id}
                        toast={latestToast}
                        onClose={() => onRemove(latestToast.id)}
                    />
                </div>
            )}
        </div>,
        document.body
    );
};